<template>
  <div
    class="page-top-con"
    :style="{ '--font_color': fontColor }"
    :class="{ 'page-top-home-con': currentObj.type == 'index' }"
  >
    <div class="page-top-header">
      <div class="page-top-header-left">
        <div class="menu-icon" @click="drawer = !drawer">
          <div class="menu-round-con" v-for="item in 3" :key="item">
            <div class="menu-round-item"></div>
            <div class="menu-round-item"></div>
            <div class="menu-round-item"></div>
          </div>
        </div>

        <template>
          <img
            :src="logo"
            class="home-logo"
            v-if="$route.name == 'home'"
            @click="goHome()"
          />
          <img
            :src="logoWhite"
            class="home-logo"
            v-if="
              currentObj.title == 'companyListSearch' ||
              currentObj.title == 'companyDetails'
            "
            @click="goHome()"
          />
          <img
            :src="logo"
            class="home-logo"
            v-if="$route.name == 'sanctionIndex'"
            @click="goPage('/sanction/index?selectCode=4')"
          />
          <img
            :src="logoWhite"
            class="home-logo"
            v-if="
              $route.path.includes('sanction') && currentObj.type != 'index'
            "
            @click="goPage('/sanction/index?selectCode=4')"
          />
          <img
            :src="logo"
            class="home-logo"
            v-if="$route.name == 'newsIndex'"
            @click="goPage('/news/index')"
          />
          <img
            :src="logoWhite"
            class="home-logo"
            v-if="$route.path.includes('news') && currentObj.type != 'index'"
            @click="goPage('/news/index')"
          />
          <img
            :src="logo"
            class="home-logo"
            v-if="$route.name == 'dataServicesIndex'"
            @click="goPage('/dataServices/index')"
          />
          <img
            :src="logoWhite"
            class="home-logo"
            v-if="
              $route.path.includes('dataServices') && currentObj.type != 'index'
            "
            @click="goPage('/dataServices/index')"
          />
          <img
            :src="logo"
            class="home-logo"
            v-if="$route.name == 'uboIndex'"
            @click="goPage('/ubo/index')"
          />
          <img
            :src="logoWhite"
            class="home-logo"
            v-if="$route.path.includes('ubo') && currentObj.type != 'index'"
            @click="goPage('/ubo/index')"
          />
          <img
            :src="logo"
            class="home-logo"
            v-if="$route.name == 'leadsIndex'"
            @click="goPage('/leads/index')"
          />
          <img
            :src="logoWhite"
            class="home-logo"
            v-if="$route.path.includes('leads') && currentObj.type != 'index'"
            @click="goPage('/leads/index')"
          />
          <img
            :src="logo"
            class="home-logo"
            v-if="$route.name == 'tradeIndex'"
            @click="goPage('/trade/index')"
          />
          <img
            :src="logoWhite"
            class="home-logo"
            v-if="
              currentObj.title == 'TradeProductDetails' ||
              currentObj.title == 'TradeDetails' ||
              currentObj.title == 'TradeCountryDetails'
            "
            @click="goPage('/trade/index')"
          />
          <img
            :src="logoWhite"
            class="home-logo"
            v-if="$route.path.includes('riskScanning')"
            @click="goPage('/home')"
          />

          <span
            class="home-logo-text"
            v-if="
              $route.name == 'home' ||
              currentObj.title == 'companyListSearch' ||
              currentObj.title == 'companyDetails'
            "
            @click="goHome()"
            >{{ $t("Home.SearchCompanies") }}</span
          >
          <span
            class="home-logo-text"
            v-if="
              $route.name == 'sanctionIndex' ||
              currentObj.title == 'SanctionList'
            "
            @click="goPage('/sanction/index?selectCode=4')"
            >{{ $t("Home.SearchSanctions") }}</span
          >
          <span
            class="home-logo-text"
            v-if="$route.name == 'newsIndex' || currentObj.title == 'NewsList'"
            @click="goPage('/news/index')"
            >{{ $t("Home.SearchNews") }}</span
          >
          <span
            class="home-logo-text"
            v-if="
              $route.name == 'dataServicesIndex' ||
              $route.path.includes('dataServices')
            "
            @click="goPage('/dataServices/index')"
            >{{ $t("Home.DataServices") }}</span
          >
          <span
            class="home-logo-text"
            v-if="$route.name == 'uboIndex' || $route.path.includes('ubo')"
            @click="goPage('/ubo/index')"
            >{{ $t("Home.SearchRelationship") }}</span
          >
          <span
            class="home-logo-text"
            v-if="
              $route.name == 'leadsIndex' ||
              $route.path.includes('/index/list/risk')
            "
            @click="goPage('/leads/index')"
            >{{ $t("Home.SearchLeads") }}</span
          >
          <span
            class="home-logo-text"
            v-if="
              $route.name == 'tradeIndex' ||
              currentObj.title == 'TradeProductDetails' ||
              currentObj.title == 'TradeDetails' ||
              currentObj.title == 'TradeCountryDetails'
            "
            @click="goPage('/trade/index')"
            >{{ $t("Home.SearchTrade") }}</span
          >
          <span
            class="home-logo-text"
            v-if="$route.path.includes('riskScanning')"
            @click="goPage('/home')"
            >{{ $t("Home.RiskScan") }}</span
          >
        </template>
      </div>
      <SearchCon
        :keyword="$route.query.keyword"
        :countryCode="$route.query.selectCode"
        v-if="
          currentObj.type != 'index' &&
          !$route.path.includes('dataServices') &&
          $route.name != 'home'
        "
        @searchFn="onSearchFn"
      ></SearchCon>

      <div class="page-top-header-right">
        <div
          id="cda00e"
          v-if="$route.meta.type == 'index' || $route.name == 'home'"
        >
          <div
            class="fontffffff font16 cuspoint textCenter WhatNew"
            @click="OpenWhatNew('')"
          >
            What's New?
          </div>
        </div>
        <!-- 集团 -->
        <div
          v-if="userInfo?.userInfo?.userType == '3'"
          class="page-top-header-item"
          id="header-icon0"
        >
          <el-popover
            :popper-class="popoverListClass"
            placement="bottom"
            trigger="click"
            v-model="isShowGroup"
          >
            <div class="list-popper-con">
              <div
                class="list-popper-con-item"
                :class="{
                  active: item.title == activeGroup,
                }"
                v-for="(item, index) in groupList"
                :key="index"
                @click="onChangeGroup(item.url)"
              >
                <div class="list-popper-con-item-name">{{ item.title }}</div>
              </div>
            </div>
            <i
              slot="reference"
              class="iconfont icon-zuyuan page-top-header-right-icon"
              @click="onOption('0')"
            ></i>
          </el-popover>
        </div>
        <!-- 消息 -->
        <div class="page-top-header-item" id="header-icon1">
          <el-badge
            :value="isLogin ? unRead.length : ''"
            :hidden="unRead.length == 0"
            class="item"
            v-if="!$route.path.includes('dataServices')"
          >
          </el-badge>
          <el-popover
            :popper-class="popoverNewsClass"
            placement="bottom-start"
            trigger="click"
            v-model="isShowNews"
          >
            <div class="news-popper-con">
              <div class="news-popper-con-top">
                <div class="news-popper-con-top-title">
                  <div class="news-popper-con-top-title-txt">Notifications</div>
                  <div
                    class="news-popper-con-top-title-num"
                    v-if="unRead.length"
                  >
                    {{ unRead.length }}
                  </div>
                </div>
                <div class="news-popper-con-top-list">
                  <div class="news-popper-con-top-list-con">
                    <div
                      v-for="(item, index) in newsList"
                      :key="index"
                      @click="gotomessage(item)"
                      class="news-popper-con-top-list-item"
                    >
                      <img
                        class="news-popper-con-top-list-item-logo"
                        src="@/assets/images/newPage/notifyLogo.png"
                        alt=""
                      />
                      <div class="news-popper-con-top-list-item-con">
                        <div class="news-popper-con-top-list-item-title">
                          <div class="news-popper-con-top-list-item-title-txt">
                            {{ item.title }}
                          </div>
                          <div
                            v-show="item.hasRead === 0"
                            class="news-popper-con-top-list-item-title-bg"
                          ></div>
                        </div>
                        <div class="news-popper-con-top-list-item-date">
                          {{ item.createTime }}
                        </div>
                        <div
                          class="news-popper-con-top-list-item-content"
                          v-if="item.content"
                        >
                          {{ item.content }}
                        </div>
                      </div>
                    </div>
                    <div v-if="newsList.length == 0" class="news-popper-con-no">
                      <img :src="noNews" />
                      <span>There is currently no new news</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="news-popper-con-bottom">
                <el-button
                  class="notify-clear-btn"
                  @click="clearAllUnRead"
                  :disabled="newsList.length == 0"
                >
                  <i class="iconfont icon-qingchu"></i
                  >{{ $t("navigationBar.MarkasRead") }}
                </el-button>
                <el-button
                  class="notify-view-btn"
                  @click="onViewAll('/account/notifications')"
                  >{{ $t("navigationBar.Viewall") }}</el-button
                >
              </div>
            </div>
            <i
              slot="reference"
              class="iconfont icon-lingdang222 page-top-header-right-icon"
              @click="onOption('1')"
            ></i>
          </el-popover>
        </div>
        <!-- 会员 -->
        <div class="page-top-header-item" id="header-icon2">
          <el-popover
            :popper-class="popoverPointClass"
            placement="bottom"
            trigger="click"
            v-model="isShowVip"
          >
            <div class="point-popper-con">
              <div
                class="popper-con-user"
                :class="{ golden: lockType == 2, silver: lockType == 1 }"
              >
                <div class="popper-con-user-left">
                  <div
                    class="popper-con-user-left-people"
                    :class="{ 'popper-con-user-round': !imageUrl }"
                  >
                    <img
                      v-if="imageUrl"
                      class="popper-con-user-left-img"
                      :src="imageUrl"
                      alt=""
                    />
                    <div class="popper-con-user-round-text" v-else>
                      {{ userInfo?.userInfo?.firstName.substring(0, 1) }}
                    </div>
                  </div>
                  <!-- 金锁 -->
                  <img
                    v-if="lockType == 2"
                    class="popper-con-user-left-vip"
                    src="@/assets/images/newPage/goldenVip.png"
                    alt=""
                  />
                  <!-- 银锁 -->
                  <img
                    v-if="lockType == 1"
                    class="popper-con-user-left-vip"
                    src="@/assets/images/newPage/silverVip.png"
                    alt=""
                  />
                </div>
                <div class="popper-con-user-right">
                  <div class="popper-con-user-right-name">
                    {{ userInfo?.userInfo?.firstName }}
                    {{ userInfo?.userInfo?.lastName }}
                  </div>
                  <div class="popper-con-user-right-type">
                    <template v-if="lockType == 2">{{
                      $t("navigationBar.GoldSubscriber")
                    }}</template>
                    <template v-if="lockType == 1">{{
                      $t("navigationBar.SilverSubscriber")
                    }}</template>
                    <template v-if="lockType == 0">{{
                      $t("navigationBar.OrdinaryUsers")
                    }}</template>
                  </div>
                </div>
              </div>
              <div class="point-popper-con-lock">
                <div
                  v-for="(item, index) in vipsList"
                  :key="index"
                  class="point-popper-con-lock-con"
                  :class="{
                    'margin-b20': vipsList.length > 1 && item.lockType == 2,
                  }"
                >
                  <el-progress
                    class="point-popper-con-lock-progress"
                    :percentage="(item.dayUsed / item.totalDays) * 100"
                    :color="item.lockType == 2 ? '#ffa000' : '#999999'"
                    :show-text="false"
                    define-back-color="#dddddd"
                  ></el-progress>
                  <div
                    class="point-popper-con-lock-desc"
                    v-show="item.lockType == 2"
                  >
                    {{ $t("navigationBar.Goldsubscriptiondate") }} :
                    {{ item.endTime.substring(0, 10) }}
                    <template v-if="!item.isEmpty"
                      >({{ item.dayUsed }}/{{ item.totalDays }})</template
                    >
                  </div>
                  <div
                    class="point-popper-con-lock-desc"
                    v-show="item.lockType == 1"
                  >
                    {{ $t("navigationBar.Silversubscriberdate") }} :{{
                      item.endTime.substring(0, 10)
                    }}
                    <template v-if="!item.isEmpty"
                      >({{ item.dayUsed }}/{{ item.totalDays }})</template
                    >
                  </div>
                  <!-- <div
                    class="margin-t2 point-popper-con-lock-desc"
                    v-show="
                      vipsList.length > 1 && item.lockType == 1 && !item.isEmpty
                    "
                  >
                    银锁暂停，金锁用完后开启
                  </div> -->
                </div>
              </div>
              <div class="point-popper-con-point">
                <img
                  class="point-popper-con-point-icon"
                  src="@/assets/images/newPage/point.png"
                  alt=""
                />
                <div class="point-popper-con-point-desc">
                  {{ $t("navigationBar.AvailableCredits") }}:
                  {{ $store.state.app.equityType }}
                </div>
              </div>
              <el-button
                class="credit-btn"
                @click="goPage('/index/addCredit')"
                >{{ $t("navigationBar.AddCredits") }}</el-button
              >
            </div>
            <i
              slot="reference"
              class="iconfont icon-icon-test page-top-header-right-icon"
              @click="onOption('2')"
            ></i>
          </el-popover>
        </div>
        <!-- 语言 -->
        <div class="page-top-header-item" id="header-icon3">
          <el-popover
            :popper-class="popoverListClass"
            placement="bottom"
            trigger="click"
            v-model="isShowLang"
          >
            <div class="list-popper-con">
              <div
                class="list-popper-con-item"
                :class="{
                  active: item.countryCode == $store.state.app.lang,
                  dis: item.disabled,
                }"
                v-for="(item, index) in langList"
                :key="index"
                @click="selectLanguage(item)"
              >
                <img
                  class="list-popper-con-item-img"
                  :src="
                    require('../../../static' +
                      getCountryImgUrl(item.countryCodeImg))
                  "
                  alt=""
                />
                <div class="list-popper-con-item-name">
                  {{ item.countryName }}
                </div>
              </div>
            </div>
            <i
              slot="reference"
              class="iconfont icon-yuyan-02 page-top-header-right-icon"
              @click="onOption('3')"
            ></i>
          </el-popover>
        </div>
        <!-- 帮助 -->
        <div class="page-top-header-item" id="header-icon4">
          <el-popover
            :popper-class="popoverListClass"
            placement="bottom"
            trigger="click"
            v-model="isShowHelp"
          >
            <div class="list-popper-con">
              <div
                class="list-popper-con-item"
                :class="{
                  active: item.title == activeHelp,
                }"
                v-for="(item, index) in helpList"
                :key="index"
                @click="onChangeHelp(item.url)"
              >
                <div class="list-popper-con-item-name">{{ item.title }}</div>
              </div>
            </div>
            <i
              slot="reference"
              class="iconfont icon-wenhao page-top-header-right-icon"
              @click="onOption('4')"
            ></i>
          </el-popover>
        </div>
        <!-- 已登录 -->
        <div
          v-show="isLogin"
          class="new-header-img page-top-header-item"
          id="header-icon5"
        >
          <el-popover
            :popper-class="popoverPeopleClass"
            placement="bottom"
            trigger="click"
            v-model="isShowPeople"
          >
            <div class="people-popper-con">
              <div
                class="popper-con-user"
                :class="{ golden: lockType == 2, silver: lockType == 1 }"
              >
                <div class="popper-con-user-left">
                  <div
                    class="popper-con-user-left-people"
                    :class="{ 'popper-con-user-round': !imageUrl }"
                  >
                    <img
                      v-if="imageUrl"
                      class="popper-con-user-left-img"
                      :src="imageUrl"
                      alt=""
                    />
                    <div class="popper-con-user-round-text" v-else>
                      {{ userInfo?.userInfo?.firstName.substring(0, 1) }}
                    </div>
                  </div>
                  <!-- 金锁 -->
                  <img
                    v-if="lockType == 2"
                    class="popper-con-user-left-vip"
                    src="@/assets/images/newPage/goldenVip.png"
                    alt=""
                  />
                  <!-- 银锁 -->
                  <img
                    v-if="lockType == 1"
                    class="popper-con-user-left-vip"
                    src="@/assets/images/newPage/silverVip.png"
                    alt=""
                  />
                </div>
                <div class="popper-con-user-right">
                  <div class="popper-con-user-right-name">
                    {{ userInfo?.userInfo?.firstName }}
                    {{ userInfo?.userInfo?.lastName }}
                  </div>

                  <div
                    class="popper-con-user-right-type"
                    v-if="userInfo?.userInfo?.userType == '1'"
                  >
                    {{ $t("navigationBar.IndivdualAccount") }}
                  </div>
                  <div class="popper-con-user-right-type" v-else>
                    {{ $t("navigationBar.GroupAccount") }}
                  </div>
                </div>
              </div>
              <div class="people-popper-con-line"></div>
              <div class="list-popper-con">
                <div
                  class="list-popper-con-item"
                  v-for="(item, index) in peopleList"
                  :key="index"
                  @click="onChangePople(item.url)"
                >
                  <i class="iconfont" :class="item.icon"></i>{{ item.title }}
                </div>
              </div>
              <div class="people-popper-con-line"></div>
              <div class="people-popper-con-signout">
                <div class="list-popper-con-item" @click="onLogOut">
                  <i class="iconfont icon-tuichu"></i
                  >{{ $t("MyAccount.SignOut") }}
                </div>
              </div>
            </div>

            <div
              slot="reference"
              class="page-top-header-right-people"
              :class="{ 'popper-con-user-round': !imageUrl }"
              @click="onOption('5')"
            >
              <img
                v-if="imageUrl"
                :src="imageUrl"
                alt=""
                class="page-top-header-right-img"
                @click="onOption('5')"
              />
              <div class="popper-con-user-round-text" v-else>
                {{ userInfo?.userInfo?.firstName.substring(0, 1) }}
              </div>
            </div>
          </el-popover>
        </div>
        <!-- 未登录 -->
        <div
          v-show="!isLogin"
          class="page-top-header-right-login"
          @click="onLogin"
        >
          <div>Sign in</div>
          <i class="iconfont icon-wode"></i>
        </div>
        <!-- ai(首页) -->
        <div
          v-if="currentObj.type == 'index' || $route.name == 'home'"
          @click="onAIseach"
          class="AIChatBox"
        >
          <img
            src="@/assets/images/newPage/globalIcon.png"
            alt=""
            class="page-top-header-right-chat"
          />
        </div>
        <!-- ai(内容页) -->
        <div @click="onAIseach" v-else>
          <img
            src="@/assets/images/newPage/global.png"
            alt=""
            class="page-top-header-right-img"
          />
        </div>
      </div>
    </div>
    <!-- 工具栏 -->
    <slot></slot>
    <!-- 菜单 -->
    <!-- <el-drawer
      :visible.sync="drawer"
      direction="ltr"
      append-to-body
      :show-close="false"
      :modal="false"
      custom-class="slider-menu-wrap"
    >
      <div class="slider-menu-btn" @click="drawer = !drawer">
        <div class="menu-round-con" v-for="item in 3" :key="item">
          <div class="menu-round-item"></div>
          <div class="menu-round-item"></div>
          <div class="menu-round-item"></div>
        </div>
      </div>
      <div class="slider-menu-header">Application</div>
      <div
        class="slider-menu-item"
        v-for="(item, index) in menuList"
        :key="index"
        @click="
          item.path == 'out' ? goPageOutUrl(item.outUrl) : goPageUrl(item.path)
        "
      >
        <div
          class="slider-menu-img"
          :style="{ backgroundImage: 'url(' + item.img + ')' }"
        ></div>
        <div class="slider-menu-title">{{ item.title }}</div>
      </div>
    </el-drawer> -->
    <!-- 登录弹窗 -->
    <Login :loginAndCreatePop.sync="loginDialog"></Login>
    <!-- 会员提示弹窗 -->
    <Tips :dialogVisible.sync="isShowTips"></Tips>
    <!-- 聊天 -->
    <div id="c943c3" v-show="isShowChat" class="index_chart_gpt new-chart-gpt">
      <GuiChart @hide="hideChart($event)" id="gdf7da"> </GuiChart>
    </div>
    <RouterDrawe
      :RouterDrawer="drawer"
      @closeCloseDialog="clossuoDialog($event)"
    ></RouterDrawe>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import SearchCon from "@/views/newLayout/searchCon.vue";
import Login from "@/components/login.vue";
import GuiChart from "@/components/gui_chart/gui_chart.vue";
import Tips from "@/views/newLayout/tips.vue";
import { getNotificationList, markAllAsRead } from "@/api/userApi.js";
import { LoginOut } from "@/api/api.js";
import { getUserSimpleInfo } from "@/api/companyApi.js";
import bus from "@/components/bus";
import RouterDrawe from "@/components/router-drawer/drawer.vue";

export default {
  props: {
    //背景颜色
    themeColor: {
      type: String,
      default: "#ffffff",
    },
    //字体颜色
    fontColor: {
      type: String,
      default: "#ffffff",
    },
  },
  mixins: [mixins1],
  components: { SearchCon, Login, Tips, GuiChart, RouterDrawe },
  computed: {
    popoverListClass() {
      return this.currentObj.type == "index" || this.$route.name == "home"
        ? "header-popper list-popper home-popper"
        : "header-popper list-popper";
    },
    popoverNewsClass() {
      return this.currentObj.type == "index" || this.$route.name == "home"
        ? "header-popper news-popper home-popper"
        : "header-popper news-popper";
    },
    popoverPointClass() {
      return this.currentObj.type == "index" || this.$route.name == "home"
        ? "header-popper point-popper home-popper"
        : "header-popper point-popper";
    },
    popoverPeopleClass() {
      return this.currentObj.type == "index" || this.$route.name == "home"
        ? "header-popper people-popper home-popper"
        : "header-popper people-popper";
    },
  },
  data() {
    return {
      loginDialog: false,
      token: localStorage.getItem("token"),
      currentObj: {}, //当前路由meta
      logoWhite: require("@/assets/img/logoyanjing.png"),
      logo: require("@/assets/images/newPage/home-logo.png"),
      newsLogo: require("@/assets/images/newPage/newsLogo.png"),
      sanctionLogo: require("@/assets/images/newPage/search_risk_logo.png"),
      uboLogo: require("@/assets/images/newPage/ubo_logo.png"),
      noNews: require("@/assets/images/newPage/noNews.png"),

      drawer: false,
      menuList: [
        {
          img: require("@/assets/images/seachCompany.png"),
          title: "Search Companies",
          path: "/",
        },
        {
          img: require("@/assets/images/SearchTrade.png"),
          title: "Search Trade",
          path: "/trade",
        },
        {
          img: require("@/assets/images/SearchRisk.png"),
          title: "Search Risk",
          // path: "/sanction/home",
          path: "/sanction/index?selectCode=4",
        },
        // {
        //   img: require("@/assets/images/SearchCountry.png"),
        //   title: "Search Countries",
        //   path: "out",
        //   outUrl: "https://csibizsearch.com/#/?id=Search Country&show=4",
        // },
        // {
        //   img: require("@/assets/images/SearchNews.png"),
        //   title: "Search News",
        //   // path: "/news/list?keyword=&selectCode=",
        //   path: "/news/index",
        // },
        {
          img: require("@/assets/images/SearchLeads.png"),
          title: "Search Leads",
          path: "/index/list/risk?keword=2",
        },
      ],
      userType: 1,
      vipsList: [], //开通会员列表
      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
            JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,
      lockType: 0,
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
      isShowNews: false,
      unRead: [], //未读列表
      newsList: [], //消息列表
      isShowLang: false,
      activeLang: "English",
      langList: [
        {
          countryCode: "en",
          countryCodeImg: "GB",
          countryName: "English",
          disabled: false,
        },
        {
          countryCode: "jp",
          countryCodeImg: "JP",
          countryName: "Japanese",
          disabled: false,
        },
        {
          countryCode: "de",
          countryCodeImg: "DE",
          countryName: "German",
          disabled: false,
        },
        {
          countryCode: "fr",
          countryCodeImg: "FR",
          countryName: "France",
          disabled: false,
        },
        {
          countryCode: "es",
          countryCodeImg: "ES",
          countryName: "Spain",
          disabled: false,
        },
        {
          countryCode: "it",
          countryCodeImg: "IT",
          countryName: "Italy",
          disabled: false,
        },
        {
          countryCode: "nl",
          countryCodeImg: "NL",
          countryName: "Netherlands",
          disabled: false,
        },
        {
          countryCode: "pt",
          countryCodeImg: "PT",
          countryName: "Portugal",
          disabled: false,
        },
      ],
      isShowVip: false,
      isShowHelp: false,
      activeHelp: "",
      helpList: [
        {
          title: this.$t("AccountCenterMenu.FAQ"),
          url: "/account/fAQ",
        },
        {
          title: this.$t("AccountCenterMenu.Privacy"),
          url: "/account/privacyPolicy",
        },
        {
          title: this.$t("AccountCenterMenu.Terms"),
          url: "/account/terms",
        },
        {
          title: this.$t("AccountCenterMenu.ReportIssues"),
          url: "/account/reportaproblem",
        },
        {
          title: this.$t("AccountCenterMenu.UserGuide"),
          url: "/account/instructions",
        },
        {
          title: this.$t("AccountCenterMenu.AboutCSI"),
          url: "/account/About",
        },
      ],
      isShowGroup: false,
      activeGroup: "",
      groupList: [
        {
          title: this.$t("navigationBar.GroupAccount"),
          url: "/account/userGroup",
        },
        {
          title: this.$t("navigationBar.UserAccount"),
          url: "/account/user",
        },
        {
          title: this.$t("navigationBar.Roles"),
          url: "/account/roles",
        },
      ],
      isShowPeople: false,
      peopleList: [
        {
          icon: "icon-wode",
          title: "Account",
          url: "/account/myAccount",
        },
        {
          icon: "icon-shujuku-hover",
          title: "My Database",
          url: "/account/companiesViewed?type=1",
        },
        {
          icon: "icon-icon-test",
          title: "Billing and Payment",
          url: "/account/billRecord",
        },
        {
          icon: "icon-shezhi",
          title: "User Settings",
          url: "/account/UserSettings",
        },
        {
          icon: "icon-lingdang",
          title: "Messages",
          url: "/account/notifications",
        },
      ],

      isLogin: false, //是否登录
      isShowChat: false, //是否显示聊天框
      isShowTips: false, //是否显示会员提示框
    };
  },
  watch: {
    "$store.state.app.NotificationsList": {
      handler(newVal, oldVal) {
        if (this.token) {
          this.getNotificationListDetail();
        }
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    $route(to, from) {
      // 在这里处理路由变化时的逻辑
      this.currentObj = to.meta;
    },
  },
  methods: {
    OpenWhatNew() {
      let routeData = this.$router.resolve({
        path: "/whatIsNew",
      });

      window.open(routeData.href, "_blank");
    },
    clossuoDialog(value) {
      this.drawer = value;
    },
    OperationWarningShow() {
      this.$bus.$emit("show-OperationWaring-dialog", "");
    },
    onSearchFn(params, type) {
      this.$emit("onSearch", params, type);
    },
    goHome() {
      this.$router.push("/");
    },
    goPage(path) {
      this.$router.push({ path: path });
    },
    // 项目内部
    goPageUrl(path) {
      if (this.isLogin) {
        this.drawer = false;
        let href = window.location.origin + "/#" + path;
        window.open(href, "_blank");
      } else {
        this.loginDialog = true;
      }
    },
    // 跳到外部
    goPageOutUrl(path) {
      if (this.isLogin) {
        this.drawer = false;
        window.open(path, "_blank");
      } else {
        this.loginDialog = true;
      }
    },
    // 登出
    onLogOut() {
      LoginOut({}).then((res) => {
        if (res.code == "200") {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
          bus.$off("handleLogin");
          location.reload();
          // this.$router.push({ path: "/" });
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("dataCleaningField");
        } else {
          sessionStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("dataCleaningField");
          location.reload();
          // window.location.href = "/";
        }
      });
    },
    // ai点击
    onAIseach() {
      if (this.isLogin) {
        if (this.lockType == 2 || this.lockType == 3) {
          this.isShowChat = !this.isShowChat;
        } else {
          this.isShowTips = true;
        }
      } else {
        this.loginDialog = true;
      }
    },
    hideChart(value) {
      this.isShowChat = value;
    },
    onOption(type) {
      let allDom = document.querySelectorAll(".page-top-header-item");
      let dom = document.getElementById("header-icon" + type);
      if (dom.className.includes("active")) {
        dom.classList.remove("active");
      } else {
        allDom.forEach((t) => t.classList.remove("active"));
        dom.classList.add("active");
      }

      // 消息icon点击时
      if (type == 1) {
        if (!this.isLogin) {
          setTimeout(() => {
            this.isShowNews = false;
          });
          this.loginDialog = true;
        }
      } else if (type == 2) {
        // 会员icon点击时
        if (!this.isLogin) {
          setTimeout(() => {
            this.isShowVip = false;
          });
          this.loginDialog = true;
        }
      }
    },

    // 获取消息列表
    getNotificationListDetail() {
      this.unRead = [];
      getNotificationList().then((res) => {
        if (res.code === 200) {
          this.newsList = res.data;
          if (this.newsList.length > 0) {
            res.data.map((item) => {
              if (item.hasRead == 0) {
                this.unRead.push(item);
              }
            });
          }
        } else {
          this.newsList = [];
        }
      });
    },
    // 清除未读消息
    clearAllUnRead() {
      markAllAsRead().then((res) => {
        if (res.code == 200) {
          this.getNotificationListDetail();
        }
      });
    },
    // 查看全部消息
    onViewAll(url) {
      this.isShowNews = false;
      this.$router.push({
        path: url,
      });
    },
    gotomessage(item) {
      this.$router.push({
        path: "/account/notifications",
        query: {
          id: item.id,
          keword: this.$route.query.keword,
        },
      });
    },
    // 获取会员信息
    getUserSimpleInfoList() {
      getUserSimpleInfo().then((res) => {
        if (res.code == 200) {
          if (res.data.certification != 1) {
            localStorage.setItem("renzheng", true);
          }
          if (res.data.vips.length == 0) {
            res.data.vips = [
              {
                dayUsed: 0,
                startTime: "",
                endTime: "",
                lockType: 2,
                isEmpty: true,
                totalDays: 1,
              },
              {
                dayUsed: 0,
                startTime: "",
                endTime: "",
                lockType: 1,
                isEmpty: true,
                totalDays: 1,
              },
            ];
          }
          this.vipsList = res.data.vips;
          this.lockType = res.data.lockType;
          this.$store.dispatch("app/setEquityType", res.data.availablePoints);
        }
      });
    },

    onLogin() {
      const token = localStorage.getItem("token");
      if (!token) {
        this.loginDialog = true;
      }
    },
    selectLanguage(item) {
      this.$i18n.locale = item.countryCode;
      sessionStorage.setItem("language", this.$i18n.locale);
      this.$store.dispatch("app/setLang", this.$i18n.locale);
    },
    // 进入帮助中心
    onChangeHelp(url) {
      this.isShowHelp = false;
      if (this.isLogin) {
        if (url == "/account/reportaproblem" && this.lockType == 0) {
          this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
        } else if (url == "/account/instructions" && this.lockType == 2) {
          this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
        } else {
          this.$router.push({
            path: url,
          });
        }
      } else {
        this.loginDialog = true;
      }
    },
    // 进入个人中心
    onChangePople(url) {
      this.isShowPeople = false;
      if (this.isLogin) {
        this.$router.push({
          path: url,
        });
      } else {
        this.loginDialog = true;
      }
    },
    // 进入集团
    onChangeGroup(url) {
      this.isShowGroup = false;
      if (this.isLogin) {
        this.$router.push({
          path: url,
        });
      } else {
        this.loginDialog = true;
      }
    },
    handleClickOutside(event) {
      let currentDom = document.querySelectorAll(
        ".page-top-header-item.active",
      );
      if (currentDom.length) {
        // 判断点击的区域是否在元素外部
        if (currentDom[0] && !currentDom[0].contains(event.target)) {
          currentDom[0].classList.remove("active");
        }
      }
    },
  },
  mounted() {
    this.currentObj = this.$route.meta;
    this.selectLanguage({ countryCode: this.$store.state.app.lang });
    // 监听登录
    bus.$on("handleLogin", (loginCheck) => {
      this.isLogin = loginCheck;
      this.$router.go(0);
      this.getUserSimpleInfoList();
    });

    if (localStorage.getItem("token")) {
      this.isLogin = true;
      this.imageUrl =
        JSON.parse(localStorage.getItem("userInfoImg")) == undefined
          ? this.imageUrl
          : JSON.parse(localStorage.getItem("userInfoImg"));
      this.getUserSimpleInfoList();
    } else {
      this.isLogin = false;
    }
    document.addEventListener("click", this.handleClickOutside);
    if (this.$route.name == "sanctionIndex") {
      document.title = "Search Sanctions";
    } else if (this.$route.name == "home") {
      document.title = "Search Companies";
    } else if (
      this.$route.path.includes("sanction") &&
      this.$route.path.includes("List")
    ) {
      if (this.$route.path.includes("country")) {
        document.title = "Search Country Sanctions";
      } else if (this.$route.path.includes("product")) {
        document.title = "Search Product Sanctions";
      } else if (this.$route.path.includes("person")) {
        document.title = "Search Person Sanctions";
      } else if (this.$route.path.includes("company")) {
        document.title = "Search company Sanctions";
      } else {
        document.title = "Search Sanctions List";
      }
    } else if (this.$route.name == "newsIndex") {
      document.title = "Search News";
    } else if (
      this.$route.path.includes("news") &&
      this.$route.path.includes("list")
    ) {
      document.title = "Search News List";
    } else if (this.$route.name == "uboIndex") {
      document.title = "Search Relationship";
    } else if (
      this.$route.path.includes("ubo") &&
      this.$route.path.includes("list")
    ) {
      document.title = "Search Relationship List";
    } else if (this.$route.name == "leadsIndex") {
      document.title = "Search Leads";
    } else if (this.$route.path.includes("index/list/risk")) {
      document.title = "Search Leads List";
    } else if (this.$route.name == "tradeIndex") {
      document.title = "Search Trade";
    } else if (this.$route.path.includes("riskScanning")) {
      document.title = "Risk Scan";
    } else if (this.$route.path.includes("index/search/list")) {
      document.title = "Search Company List";
    } else if (this.$route.path.includes("account")) {
      document.title = "My Account";
    }
  },
  updated() {
    window.addEventListener("setItem", () => {
      this.token = localStorage.getItem("token");
    });
  },
  destroyed() {
    window.removeEventListener("setItem", () => {
      this.token = localStorage.getItem("token");
    });
  },
};
</script>
<style scoped>
.new-layout-con .page-top-con {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 999;
}
.new-layout-con .page-top-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 88px;
  padding: 0 40px 0 30px;
}
.new-layout-con .page-top-header-left {
  display: flex;
  align-items: center;
  justify-content: start;
}
.new-layout-con .page-top-header-right {
  display: flex;
  align-items: center;
  justify-content: center;
}
.new-layout-con .page-top-home-con {
  padding-bottom: 0;
}

.new-layout-con .page-top-header .menu-icon {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 28px;
  height: 28px;
  margin-right: 40px;
  cursor: pointer;
}

.menu-round-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-round-con .menu-round-item {
  width: 6px;
  height: 6px;
  background: #ffffff;
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}
.new-layout-con .page-top-home-con .menu-round-item {
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
}
.new-layout-con .page-top-header .menu-icon:hover .menu-round-item:first-child {
  width: 100%;
  height: 4px;
}
.new-layout-con
  .page-top-header
  .menu-icon:hover
  .menu-round-item:nth-last-child(-n + 2) {
  width: 0px;
}
.new-layout-con .page-top-header .home-logo {
  height: 28px;
  cursor: pointer;
}
.new-layout-con .page-top-header .news-logo {
  height: 32px;
  cursor: pointer;
}
.new-layout-con .page-top-header .sanction-logo {
  width: auto;
  height: 32px;
  cursor: pointer;
}
.new-layout-con .page-top-home-con .page-top-header-item.active::after {
  display: none !important;
}
/* 右侧 */
.new-layout-con .page-top-header-right > div {
  position: relative;
  display: flex;
}
.new-layout-con .page-top-header-right > div:not(:first-child) {
  margin-left: 30px;
}
.new-layout-con .page-top-header-item {
  position: relative;
}

.new-header-img >>> span {
  display: flex;
}
.new-layout-con .page-top-header-item.active::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 68px;
  height: 88px;
  background: rgba(0, 0, 0, 0.1);
}
.new-layout-con .page-top-header-right .page-top-header-right-icon {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  font-size: 22px;
  color: #ffffff;
  cursor: pointer;
  z-index: 2;
}
.new-layout-con .page-top-header-right .icon-wenhao,
.new-layout-con .page-top-header-right .icon-lingdang222 {
  font-size: 22px;
}
.new-layout-con .page-top-header-right .icon-zuyuan {
  font-size: 26px;
}
.new-layout-con .page-top-header-right .icon-yuyan-02 {
  font-size: 27px;
}
.new-layout-con .page-top-header-right .icon-icon-test {
  font-size: 30px;
}
.new-layout-con .page-top-header-right-people {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f5f5f5;
  cursor: pointer;
  z-index: 2;
}
.new-layout-con .page-top-header-right-img {
  width: 48px;
  height: 48px;
  cursor: pointer;
  border-radius: 50%;
}
.AIChatBox {
  margin-left: 26px !important;
  height: 48px;
  display: flex;
  align-items: center;
}
.new-layout-con .page-top-header-right-chat {
  width: 52px;
  height: 38px;
  cursor: pointer;
}
.new-layout-con .page-top-header-right-login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  cursor: pointer;
  border-color: var(--font_color);
}
.new-layout-con .page-top-header-right-login > div {
  margin-right: 8px;
  font-size: 16px;
  color: var(--font_color);
}
.new-layout-con .page-top-header-right-login > i {
  font-size: 22px;
  color: var(--font_color);
}
.news-popper-con-top {
  padding: 20px 0 0 0;
}
.news-popper-con-top-title {
  display: flex;
  align-items: center;
  height: 24px;
  margin-bottom: 10px;
  padding: 0 20px;
}
.news-popper-con-top-title-txt {
  font-size: 20px;
  color: #1a2332;
}
.news-popper-con-top-title-num {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-left: 4px;
  font-size: 12px;
  color: #ffffff;
  background: #f56c6c;
  border-radius: 50%;
}
.news-popper-con-top-list {
  width: 100%;
  max-height: 21.8rem;
  padding-left: 20px;
  overflow-y: auto;
}
.news-popper-con-top-list-con {
  width: 390px;
}
.news-popper-con-no {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
}
.news-popper-con-no img {
  width: 204px;
  height: 204px;
  margin-bottom: 10px;
}
.news-popper-con-no span {
  font-size: 18px;
  color: #999999;
}
.news-popper-con-top-list-item {
  display: flex;
  padding: 20px 0;
  border-top: 1px solid #dddddd;
}
.news-popper-con-top-list-item-logo {
  display: flex;
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.news-popper-con-top-list-item-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.news-popper-con-top-list-item-title-txt {
  line-height: 20px;
  font-family: "Arial Bold";
  font-size: 18px;
  color: #1a2332;
}
.news-popper-con-top-list-item-title-bg {
  width: 10px;
  height: 10px;
  margin-top: 5px;
  margin-left: 6px;
  background: #f56c6c;
  border-radius: 50%;
}
.news-popper-con-top-list-item-date {
  line-height: 16px;

  font-size: 14px;
  color: #999999;
}
.news-popper-con-top-list-item-con {
  flex-grow: 1;
}
.news-popper-con-top-list-item-content {
  line-height: 20px;
  padding: 10px;
  margin-top: 14px;
  font-size: 16px;
  color: #1a2332;
  background: #f5f5f5;
  border-radius: 6px;
  display: none;
}
.news-popper-con-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 66px;
  padding: 0 20px;
  background: #ffffff;
  border-top: 1px solid #dddddd;
}
.notify-clear-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  min-width: 200px !important;
  height: 40px;
  min-height: 40px !important;
  padding: 0 !important;
  font-size: 18px !important;
  color: #1a2332;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #dddddd;
}
.notify-clear-btn.is-disabled {
  color: #999999;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.notify-clear-btn >>> span {
  display: flex;
}
.notify-clear-btn i {
  display: flex;
  width: 18px;
  height: 18px;
  margin-right: 10px;
  font-size: 18px;
}
.notify-view-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  min-width: 120px !important;
  height: 40px;
  min-height: 40px !important;
  padding: 0 !important;
  font-size: 18px !important;
  color: #ffffff;
  border-radius: 10px;
  border: 1px solid #dddddd;
  background: #1290c9;
}
.credit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 120px !important;
  height: 40px;
  min-height: 40px !important;
  padding: 0 !important;
  font-size: 18px !important;
  color: #ffffff;
  border-radius: 10px;
  background: #1290c9;
}
.home-popper .notify-view-btn,
.home-popper .credit-btn {
  background: #1290c9;
}
.news-theme .notify-view-btn,
.news-theme .credit-btn {
  background: #3ebb72;
}
.sanction-theme .notify-view-btn,
.sanction-theme .credit-btn {
  background: #f9722c;
}

.list-popper-con {
  padding: 10px 0;
}
.list-popper-con-item {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 20px;
  font-size: 20px;
  color: #1a2332;
  cursor: pointer;
}
.list-popper-con-item i {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  margin-right: 16px;
  font-size: 26px;
  color: #1a2332;
}
.list-popper-con-item .icon-shujuku-hover {
  font-size: 21px;
}
.list-popper-con-item .icon-lingdang {
  font-size: 23px;
}
.list-popper-con-item .icon-tuichu {
  font-size: 30px;
  padding-top: 3px;
}
.home-popper .active.list-popper-con-item,
.home-popper .list-popper-con-item:hover {
  color: #1290c9;
}
.news-theme .active.list-popper-con-item,
.news-theme .list-popper-con-item:hover {
  color: #3ebb72;
}
.sanction-theme .active.list-popper-con-item,
.sanction-theme .list-popper-con-item:hover {
  color: #f9722c;
}
.news-theme .active.list-popper-con-item i,
.news-theme .list-popper-con-item:hover i {
  color: #3ebb72;
}
.sanction-theme .active.list-popper-con-item i,
.sanction-theme .list-popper-con-item:hover i {
  color: #f9722c;
}
.html-new-page:has(.leads) .active.list-popper-con-item,
.html-new-page:has(.leads) .list-popper-con-item:hover {
  color: #8e86dd;
}
.active.list-popper-con-item,
.list-popper-con-item:hover {
  background: #f5f5f5;
}
.dis.list-popper-con-item,
.dis.list-popper-con-item:hover {
  color: #999999;
  cursor: not-allowed;
}
.list-popper-con-item-img {
  display: flex;
  width: 30px;
  height: 20px;
  margin-right: 10px;
  box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.popper-con-user {
  display: flex;
}
.point-popper-con .popper-con-user {
  margin-bottom: 24px;
}
.people-popper-con .popper-con-user {
  padding: 20px 20px 14px 20px;
}
.popper-con-user-left {
  position: relative;
  width: 60px;
  height: 60px;
  margin-right: 22px;
}
.popper-con-user-left-people {
  display: flex;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  border-radius: 50%;
}
.popper-con-user-left-people .popper-con-user-left-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #f5f5f5;
}
.popper-con-user-round {
  padding: 0 5px;
  font-size: 36px;
  color: #a2a9b0;
  white-space: nowrap;
  background: #f5f5f5;
}
.popper-con-user-round-text {
  display: block;
  width: 100%;
  line-height: 50px;
  text-align: center;
  text-transform: uppercase;
  overflow: hidden;
}
.page-top-header-right-people.popper-con-user-round {
  font-size: 28px;
}
.popper-con-user-left-vip {
  position: absolute;
  bottom: 0;
  left: 14px;
  display: flex;
  width: 58px;
  height: 22px;
}
.popper-con-user-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60px;
}
.popper-con-user-right-name {
  line-height: 24px;
  margin-bottom: 4px;
  font-size: 20px;
  color: #1a2332;
}
.popper-con-user-right-type {
  line-height: 20px;
  font-size: 16px;
  color: #8497ab;
}
.golden .popper-con-user-right-type {
  color: #bc8553;
}
.silver .popper-con-user-right-type {
  color: #666666;
}
.point-popper-con-lock {
  padding-bottom: 10px;
  margin-bottom: 16px;
  border-bottom: 1px solid #dddddd;
}
.point-popper-con-lock-progress {
  margin-bottom: 4px;
}
.point-popper-con-lock-progress >>> .el-progress-bar__outer {
  height: 10px !important;
}
.point-popper-con-lock-desc {
  line-height: 18px;
  font-size: 14px;
  color: #8497ab;
}
.point-popper-con-point {
  display: flex;
  margin-bottom: 20px;
}
.point-popper-con-point-icon {
  display: flex;
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.point-popper-con-point-desc {
  height: 24px;
  line-height: 24px;
  font-size: 18px;
  color: #1a2332;
}
.people-popper-con-line {
  width: 300px;
  height: 1px;
  margin: 0 auto;
  background: #dddddd;
}
.people-popper-con-signout {
  padding: 15px 0;
}
.new-chart-gpt {
  width: 600px;
}
.home-logo-text {
  font-size: 18px;
  line-height: 19px;
  color: #ffffff;
  margin-left: 12px;
  font-family: "Arial Bold";
  cursor: pointer;
}
.dataService-top {
  display: flex;
}
.WhatNew {
  border-color: #ffffff;
  color: #ffffff;
}
.u9qMull {
  font-size: 20px;
  width: 100%;
  display: inline-block;
}
/deep/ .el-badge__content {
  position: absolute;
  height: 16px;
  min-width: 16px;
  border-radius: 50%;
  padding: 0px;
  top: 0;
  right: -12px;
  transform: translateY(-50%) translateX(100%);
  z-index: 100;
}
.UBO .search_btn {
  position: absolute;
  right: -1px;
}
.UBO .WhatNew {
  box-shadow: 0px 1px 1px 0px #603c2c;
  text-shadow: 0px 1px 1px #603c2c;
}
.UBO .page-top-header-right-icon {
  text-shadow: 0px 1px 1px #603c2c;
}
.UBO .page-top-header-right-login {
  border-color: #ffffff !important;
  box-shadow: 0px 1px 1px 0px #603c2c;
}
.UBO .page-top-header-right-login div {
  color: #ffffff;
  text-shadow: 0px 1px 1px #603c2c;
}
.UBO .page-top-header-right-login i {
  color: #ffffff;
  text-shadow: 0px 1px 1px #603c2c;
}

@media (max-width: 1920px) {
  .home-logo-text {
    font-size: 16px;
    line-height: 17px;
    margin-left: 10px;
  }
  .new-layout-con .page-top-header {
    height: 66px;
    padding: 0 30px 0 22px;
  }

  .new-layout-con .page-top-header .menu-icon {
    width: 22px;
    height: 22px;
    margin-right: 26px;
  }
  .menu-round-con .menu-round-item {
    width: 4px;
    height: 4px;
    border-radius: 2px;
  }
  .new-layout-con .page-top-home-con .menu-round-item {
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.5);
  }
  .new-layout-con
    .page-top-header
    .menu-icon:hover
    .menu-round-item:first-child {
    height: 2px;
  }
  .new-layout-con .page-top-header .home-logo {
    height: 22px;
  }
  .new-layout-con .page-top-header .news-logo {
    height: 21px;
  }
  .new-layout-con .page-top-header .sanction-logo {
    height: 18px;
  }
  /* 右侧 */
  .new-layout-con .page-top-header-right > div:not(:first-child) {
    margin-left: 22px;
  }
  .new-layout-con .page-top-header-item.active::after {
    width: 45px;
    height: 58px;
  }

  .new-layout-con .page-top-header-right .page-top-header-right-icon {
    width: 18px;
    height: 18px;
    font-size: 18px;
  }
  .new-layout-con .page-top-header-right .iconfont.icon-wenhao {
    font-size: 20px;
  }
  .new-layout-con .page-top-header-right .icon-lingdang222 {
    font-size: 18px;
  }
  .new-layout-con .page-top-header-right .icon-zuyuan {
    font-size: 23px;
  }
  .new-layout-con .page-top-header-right .icon-yuyan-02 {
    font-size: 22px;
  }
  .new-layout-con .page-top-header-right .icon-icon-test {
    font-size: 24px;
  }
  .new-layout-con .page-top-header-right-people {
    width: 32px;
    height: 32px;
  }
  .new-layout-con .page-top-header-right-img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
  .AIChatBox {
    margin-left: 19px !important;
    height: 32px;
  }
  .new-layout-con .page-top-header-right-chat {
    width: 35px;
    height: 25px;
  }
  .new-layout-con .page-top-header-right-login {
    width: 82px;
    height: 30px;
    border-radius: 15px;
  }
  .new-layout-con .page-top-header-right-login > div {
    margin-right: 5px;
    font-size: 14px;
  }
  .new-layout-con .page-top-header-right-login > i {
    font-size: 18px;
  }
  .news-popper-con-top {
    padding: 14px 0 0 0;
  }
  .news-popper-con-top-title {
    height: 18px;
    margin-bottom: 6px;
    padding: 0 14px;
  }
  .news-popper-con-top-title-txt {
    font-size: 16px;
  }
  .news-popper-con-top-title-num {
    width: 16px;
    height: 16px;
    margin-left: 3px;
  }
  .news-popper-con-top-list {
    max-height: 21.8rem;
    /* min-height: 252px; */
    padding-left: 14px;
  }
  .news-popper-con-top-list-con {
    width: 270px;
  }
  .news-popper-con-no {
    padding-top: 26px;
  }
  .news-popper-con-no img {
    width: 140px;
    height: 140px;
    margin-bottom: 6px;
  }
  .news-popper-con-no span {
    font-size: 14px;
  }
  .news-popper-con-top-list-item {
    padding: 14px 0;
  }
  .news-popper-con-top-list-item-logo {
    width: 28px;
    height: 28px;
    margin-right: 7px;
  }
  .news-popper-con-top-list-item-title {
    margin-bottom: 5px;
  }
  .news-popper-con-top-list-item-title-txt {
    line-height: 16px;
    font-size: 14px;
  }
  .news-popper-con-top-list-item-title-bg {
    width: 7px;
    height: 7px;
    margin-top: 3px;
    margin-left: 4px;
  }
  .news-popper-con-top-list-item-date {
    line-height: 14px;
    margin-bottom: 10px;
    font-size: 12px;
  }
  .news-popper-con-top-list-item-content {
    line-height: 14px;
    padding: 6px;
    font-size: 12px;
    border-radius: 4px;
  }
  .news-popper-con-bottom {
    height: 44px;
    padding: 0 14px;
  }
  .notify-clear-btn {
    width: 140px;
    min-width: 140px !important;
    height: 28px;
    min-height: 28px !important;
    font-size: 14px !important;
    border-radius: 6px;
  }
  .notify-clear-btn i {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    font-size: 14px;
  }
  .notify-view-btn {
    width: 80px;
    min-width: 80px !important;
    height: 28px;
    min-height: 28px !important;
    font-size: 14px !important;
    border-radius: 6px;
  }
  .credit-btn {
    min-width: 80px !important;
    height: 28px;
    min-height: 28px !important;
    font-size: 14px !important;
    border-radius: 6px;
  }
  .list-popper-con {
    padding: 6px 0;
  }
  .list-popper-con-item {
    height: 35px;
    padding: 0 14px;
    font-size: 16px;
  }
  .list-popper-con-item i {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    font-size: 22px;
  }
  .list-popper-con-item .icon-shujuku-hover {
    font-size: 17px;
  }
  .list-popper-con-item .icon-lingdang {
    font-size: 19px;
  }
  .list-popper-con-item .icon-tuichu {
    font-size: 26px;
    padding-top: 2px;
  }
  .list-popper-con-item-img {
    width: 20px;
    height: 14px;
    margin-right: 6px;
  }
  .point-popper-con .popper-con-user {
    margin-bottom: 16px;
  }
  .people-popper-con .popper-con-user {
    padding: 14px 14px 10px 14px;
  }
  .popper-con-user-left {
    width: 40px;
    height: 40px;
    margin-right: 15px;
  }
  .popper-con-user-round {
    padding: 0 3px;
    font-size: 24px;
  }
  .popper-con-user-round-text {
    line-height: 40px;
  }
  .page-top-header-right-people.popper-con-user-round {
    font-size: 20px;
  }
  .page-top-header-right-people .popper-con-user-round-text {
    line-height: 32px;
  }
  .popper-con-user-left-vip {
    left: 9px;
    width: 38px;
    height: 15px;
  }
  .popper-con-user-right {
    height: 40px;
  }
  .popper-con-user-right-name {
    line-height: 16px;
    margin-bottom: 3px;
    font-size: 14px;
  }
  .popper-con-user-right-type {
    line-height: 14px;
    font-size: 12px;
  }
  .point-popper-con-lock {
    padding-bottom: 6px;
    margin-bottom: 10px;
  }
  .point-popper-con-lock-progress {
    margin-bottom: 3px;
  }
  .point-popper-con-lock-progress >>> .el-progress-bar__outer {
    height: 7px !important;
  }
  .point-popper-con-lock-desc {
    line-height: 14px;
    font-size: 12px;
  }
  .point-popper-con-point {
    margin-bottom: 14px;
  }
  .point-popper-con-point-icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .point-popper-con-point-desc {
    height: 16px;
    line-height: 16px;
    font-size: 14px;
  }
  .people-popper-con-line {
    width: 200px;
  }
  .people-popper-con-signout {
    padding: 10px 0;
  }
  .u9qMull {
    font-size: 18px;
  }
  /deep/ .el-badge__content {
    right: -9px;
  }
}
@media (max-width: 1439px) {
  .new-layout-con .page-top-header {
    padding: 0 10px 0 14px;
  }
}
</style>
